import NetworkService from '../services/network.service'

class InvoiceApi {
  getInvoices = async (query: any, isIndependent=false) => {
    let url = `api/invoices`;
    let config = {
      params: {
        query: query,
        isIndependent: isIndependent
      }
    }
    let data = await NetworkService.get(url, config)
    return data && data.data
      ? data.data : data

  };
  deleteInvoice = async (id: any) => {
    try {
      let url = `api/invoices/delete`;
      let body = { id: id };
      let data = await NetworkService.delete(url, body)
      return data && data.data
        ? data.data : data
    } catch (err: any) {
      return err.description ? err.description : err;
    }
  }
  // following function is no longer used
  // deleteInvoice = async (invoiceId: any) => {
  //   let url = `api/invoices`;
  //   let body = {
  //     id: invoiceId
  //   }
  //   let data = await NetworkService.delete(url, body)
  //   return data && data.data
  //     ? data.data : data
  // }

}
export default InvoiceApi;